<template>
  <v-data-table
    :headers="headers"
    :items="referencias"
    class="transparent"
    :options="{ page: false }"
    :hide-default-footer="true"
    calculate-widths
  >
    <template v-slot:[`item.direccion`]="{ item }">
      <section>
        {{
          `${item.calle} ${item.interior ?? 'S/N'} entre calles ${item.entrecalles} y ${item.entrecalles2}, ${
            item.colonia
          }, ${item.localidad},`
        }}
      </section>
      <section v-if="item.municipio && item.estado">
        {{ `${item.municipio}, ${item.estado} CP #${item.cp}` }}
      </section>
      <section v-if="item.referencias">Referencia: {{ item.referencias }}</section>
    </template>
    <template v-slot:[`item.opciones`]="{ item }">
      <span class="d-flex align-center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <IconButton class="mr-2" icon="mdi-pencil" variant="primary" @click="$emit('edit', item)" />
            </span>
          </template>
          <span>Editar Referencia</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <IconButton icon="mdi-delete" variant="error" @click="$emit('delete', item)" />
            </span>
          </template>
          <span>Eliminar Referencia</span>
        </v-tooltip>
      </span>
    </template>
  </v-data-table>
</template>

<script>
import IconButton from '../base/IconButton.vue'

export default {
  components: { IconButton },

  props: {
    referencias: {
      type: Array,
      required: true,
    },

    type: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      personalHeaders: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Teléfono', value: 'telefono' },
        {
          text: 'Años de conocerlo',
          value: 'tiempoConocerse',
          align: 'right',
        },
        { text: '¿Cómo lo conoció?', value: 'comoConocio', align: 'right' },
        { text: 'Opciones', value: 'opciones' },
      ],

      laboralHeaders: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Teléfono', value: 'telefono' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Cargo', value: 'cargo' },
        { text: 'Corporación, Institución o Empresa', value: 'corporacion' },
        { text: 'Tiempo laborado (años)', value: 'tiempoLaborado', align: 'right' },
        { text: 'Opciones', value: 'opciones' },
      ],

      vecinalHeaders: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Teléfono', value: 'telefono' },
        { text: 'Tiempo de ser vecinos (años)', value: 'tiempoConocerse', align: 'right' },
        { text: 'Dirección', value: 'direccion' },
        { text: 'Opciones', value: 'opciones' },
      ],
    }
  },

  computed: {
    headers() {
      if (this.type === 'laboral') return this.laboralHeaders
      if (this.type === 'vecinal') return this.vecinalHeaders

      return this.personalHeaders
    },
  },
}
</script>
